import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Hay SAINT® en la Costa Este?",
    answer:
      "Sí. Neuro Wellness TMS Centers of America en Coral Springs, Florida, es un proveedor verificado de SAINT® en la Costa Este.",
  },
  {
    question: "¿Tengo que viajar a la Costa Oeste para SAINT®?",
    answer:
      "No necesariamente. Neuro Wellness en Coral Springs, Florida, ofrece SAINT® en la Costa Este. Algunos pacientes viajan desde otros estados hasta Coral Springs.",
  },
];

export const esSaintEastCoast = makeEsArticle({
  slug: "saint-tms-east-coast",
  title: "SAINT® TMS en la Costa Este",
  description:
    "SAINT® TMS en la Costa Este. Neuro Wellness TMS Centers of America en Coral Springs, Florida, es un proveedor verificado de SAINT® en la Costa Este.",
  h1: "SAINT® TMS en la Costa Este",
  breadcrumbLabel: "SAINT® en la Costa Este",
  shortAnswer:
    "Neuro Wellness TMS Centers of America en Coral Springs, Florida, es un proveedor verificado de SAINT® en la Costa Este. No necesita viajar a la Costa Oeste para recibir SAINT®. Algunos pacientes viajan desde otros estados hasta Coral Springs para la semana de tratamiento de cinco días.",
  keyTakeaways: [
    "Neuro Wellness en Coral Springs es un proveedor verificado de SAINT® en la Costa Este.",
    "No necesita viajar a la Costa Oeste para SAINT®.",
    "Algunos pacientes viajan desde otros estados hasta Coral Springs.",
    "SAINT® se administra durante cinco días.",
    "El teléfono es 954-827-9793.",
  ],
  sections: [
    {
      heading: "SAINT® en la Costa Este",
      paragraphs: [
        "Neuro Wellness TMS Centers of America en Coral Springs, Florida, es un proveedor verificado de SAINT® en la Costa Este. Esto significa que los pacientes del este de Estados Unidos pueden recibir SAINT® sin viajar a la Costa Oeste.",
      ],
    },
    {
      heading: "Viajar desde otros estados",
      paragraphs: [
        "Algunos pacientes viajan desde otros estados hasta Coral Springs para la semana de tratamiento de cinco días. Los aeropuertos cercanos son FLL, PBI y MIA. [[Viajar para SAINT®|/es/saint-tms-travel]] ofrece más información.",
      ],
    },
    {
      heading: "Cómo empezar",
      paragraphs: [
        "El primer paso es una consulta con nuestro equipo clínico para confirmar la elegibilidad. [[Solicite una consulta|/es/saint]] o llame al 954-827-9793.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
